const membersTypes = {
  regularMembers: 'regularMembers',
  guests: 'guests'
} as const;

export const memberCapacitiesTableConstants = { membersTypes };
